import Vue from 'vue';
import VeeValidate from 'vee-validate';
import JsonExcel from 'vue-json-excel';

import App from './App';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css'
import * as uiv from 'uiv'
import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)
Vue.use(uiv);
Vue.component('downloadExcel', JsonExcel);
Vue.use(VeeValidate);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

require('./styles/main.scss');
